import emUtils from "@/utils/emUtils";
import axios from "axios";

export default {
    install(Vue, router, store) {
        Vue.directive('menuPermission', {
                bind: function (el, binding, vnode) {
                    bindFunction(el, binding, vnode, "menu")
                }
            }
        );
        Vue.directive('apiPermission', {
                bind: function (el, binding, vnode) {
                    bindFunction(el, binding, vnode, "url")
                }
            }
        )

        // if (!router) {
        //     console.error('Router not defined!');
        // }
        //
        // router.beforeEach((to, from, next) => {
        //     if (keycloak.isTokenExpired()) {
        //         localStorage.removeItem('kc_token')
        //         localStorage.removeItem('kc_refreshToken')
        //         store.dispatch('auth/logout', {root: true})
        //             .then(function() {
        //                 keycloak.logout({ redirectUri: process.env.VUE_APP_LOGOUT_URL })
        //             })
        //     }
        //     else if (to.meta.requiresAuth) {
        //         const auth = keycloak.authenticated;
        //         if (!auth) {
        //             window.location.reload()
        //         }
        //         else {
        //             if (to.meta.roles) {
        //                 if (keycloak.hasRealmRole(to.meta.roles[0])) {
        //                     next();
        //                 }
        //                 else {
        //                     next({ name: 'Unauthorized' });
        //                 }
        //             }
        //             else {
        //                 next();
        //             }
        //         }
        //     }
        //     else {
        //         next();
        //     }
        // });

        Vue.prototype.$authentication = {
            logout: function (store) {
                let ssoApiBaseUrl = process.env.VUE_APP_EM_SSO_URL
                let ssoApiBaseUrlLoginUrl = process.env.VUE_APP_EM_SSO_LOGIN_URL
                localStorage.removeItem('em_sso_token')
                //同时清除em的用户权限缓存
                localStorage.removeItem('em_userAclsAndRoles')
                localStorage.removeItem('return_url')
                // store.dispatch('auth/logout', {root: true})
                //     .then(function() {
                //         keycloak.logout({ redirectUri: process.env.VUE_APP_LOGOUT_URL })
                //     })
                store.dispatch('userStore/clear', {root: true});
                axios.defaults.withCredentials = true;
                axios.post(`${ssoApiBaseUrl}/logout`)
                    .then(res => {
                        console.log(res)
                        if (res.data.code === 200) {
                            window.location.href = ssoApiBaseUrlLoginUrl;
                        } else {
                            // alert(res.data.msg);
                            console.log(res.data.msg);
                            window.location.href = ssoApiBaseUrlLoginUrl;
                        }
                    });
            }
        }

    }
}

function bindFunction(el, binding, vnode, by) {
    //如果启用了权限
    if (process.env.VUE_APP_EM_SSO_ENABLE === 'true') {
        //判断权限
        if (!hasPermission(el, binding, vnode, by && by === "menu" ? hasMenuPermission : hasApiPermission)) {
            if (el.nodeName.toLowerCase() === 'button') {
                el.disabled = true
            } else {
                vnode.elm.hidden = true
            }
        }
    }
}

const aclMap = {
    'list': 2,
    'new': 3,
    'edit': 5,
    'delete': 7
};

function hasPermission(el, binding, vnode, checkFunction) {
    //获取当前用户的权限数据，（vuex，vnode.context相当于组件中的this)

    const userAclsAndRoles = vnode.context.$store.state['emMenu'].userAclsAndRoles
    return isSupperAdmin(userAclsAndRoles) || (checkFunction && checkFunction(el, binding, vnode, userAclsAndRoles))
}

function getEntity(vnode) {
    const context = vnode.context
    // 保存按钮
    if (context._props && context.$vnode.data.ref === 'emEntityEditForm') {
        return context._props.entity;
    }
    // editForm的控制
    if (context.$refs.emEntityEditForm && context.$refs.emEntityEditForm._props) {
        return context.$refs.emEntityEditForm._props.entity;
    }
}

function hasMenuPermission(el, binding, vnode, userAclsAndRoles) {
    //获取绑定值
    let componentNeedAcl = binding.value
    const entity = getEntity(vnode)
    if (entity) {
        // 参考$_emCommonEditMixin_pathType的逻辑
        const crudState = vnode.context.$store.state[entity].crudState
        if (componentNeedAcl === 'edit' && (crudState === 'new' || !crudState)) {
            componentNeedAcl = 'new'
        }
    }
    //获取URI
    const baseUri = el.baseURI
    //获取url的queryParams
    const urlParams = emUtils.getUrlQueryParams(baseUri);
    const menuId = urlParams['menuId']
    const url = emUtils.getServletUrl(baseUri)
    const componentNeedAclLevel = aclMap[componentNeedAcl]
    if (userAclsAndRoles && componentNeedAcl && urlParams) {
        if (menuId && url) {
            //如果权限列表中存在权限等级小于等于（越小权限越大）组件所需权限等级的相同menuId，就返回true
            //调试用
            // console.log(`this is hasMenuPermission by menuId【${menuId}】,url【${url}】`)
            // console.log(`componentNeedAclLevel【${componentNeedAcl}】`)
            // let matchAcl = userAclsAndRoles.aclList && userAclsAndRoles.aclList.find(acl => (acl.id + '' === menuId) && (acl.aclLevel <= componentNeedAclLevel)
            //     && (url === (acl.menuUrl.indexOf('?') === -1 ? acl.menuUrl : acl.menuUrl.slice(0, acl.menuUrl.indexOf('?')))))
            // console.log("matchAcl is")
            // console.log(matchAcl)
            // return matchAcl !== undefined

            return userAclsAndRoles.aclList && userAclsAndRoles.aclList.some(acl => (acl.id + '' === menuId) && (acl.aclLevels.includes(componentNeedAclLevel))
                && (url === (acl.menuUrl.indexOf('?') === -1 ? acl.menuUrl : acl.menuUrl.slice(0, acl.menuUrl.indexOf('?')))))
        } else if (url) {
            //调试用
            // console.log(`this is hasMenuPermission by url【${url}】`)
            // console.log(`componentNeedAclLevel【${componentNeedAcl}】`)
            // //如果menuUrl中配置了参数，需要先过滤调，用纯url路径来比较
            // let matchAcl = userAclsAndRoles.aclList && userAclsAndRoles.aclList.find(acl => url === (acl.menuUrl.indexOf('?') === -1
            //     ? acl.menuUrl : acl.menuUrl.slice(0, acl.menuUrl.indexOf('?'))) && acl.aclLevel <= componentNeedAclLevel)
            // console.log("matchAcl is")
            // console.log(matchAcl)
            // return matchAcl !== undefined

            return userAclsAndRoles.aclList && userAclsAndRoles.aclList.some(acl => url === (acl.menuUrl.indexOf('?') === -1
                ? acl.menuUrl : acl.menuUrl.slice(0, acl.menuUrl.indexOf('?'))) && acl.aclLevels.includes(componentNeedAclLevel))
        }
    }
    return false
}

function hasApiPermission(el, binding, vnode, userAclsAndRoles) {
    //获取绑定值，格式应该是['api','aclLevel'],e.g : v-api-permission="['xxxx','edit']"
    const componentNeedApiAcl = binding.value[0]
    const componentNeedAcl = binding.value[1]
    //组件需要的权限等级：1读写，2只读
    const componentNeedAclLevel = aclMap[componentNeedAcl]
    if (userAclsAndRoles && componentNeedAcl && componentNeedApiAcl && componentNeedAcl) {
        return userAclsAndRoles.aclList && userAclsAndRoles.aclList.some(acl => acl.aclUrl === componentNeedApiAcl && acl.aclLevels.includes(componentNeedAclLevel))
    }
    return false
}

function isSupperAdmin(userAclsAndRoles) {
    return userAclsAndRoles && userAclsAndRoles.supperAdmin
}
